import PropTypes from 'prop-types';
import {memo, useCallback} from 'react';

import {SEARCH_FILTERS} from '@/src/app/constants/search';
import TextLocal from '@/src/textLocal/containers/TextLocal';

import {CheckboxCommon, SimpleCollapse, Text} from '../../ui';
import FilterRow from './FilterRow';

const CategoriesFilters = ({
  query,
  onMultipleFilterClickHandle,
  courseCategories,
  locale,
}) => {
  const getId = useCallback(
    (category) =>
      category?.children?.length > 0
        ? category.children.map(({id}) => id.toString())
        : [category.id.toString()],
    []
  );

  const isParentChecked = useCallback((appliedFilters, itemFilters) => {
    return itemFilters.every((elem) => appliedFilters.includes(elem));
  }, []);

  return (
    <SimpleCollapse
      defaultIsOpen
      headTitle={
        <Text
          fontSize={Text.FONT_SIZE.SIZE_16}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.categories'} />
        </Text>
      }
    >
      {courseCategories?.map((category) => (
        <FilterRow key={category.id}>
          <CheckboxCommon
            isSemibold
            id={`categorie_${category.id}`}
            name={category[`name_${locale}`]}
            label={category[`name_${locale}`]}
            data-filter-name={SEARCH_FILTERS.FILTERS_CATEGORY_IDS}
            data-value={getId(category)}
            checked={
              !!query[SEARCH_FILTERS.FILTERS_CATEGORY_IDS] &&
              isParentChecked(
                // @ts-ignore
                JSON.parse([query[SEARCH_FILTERS.FILTERS_CATEGORY_IDS]]),
                getId(category)
              )
            }
            onChange={onMultipleFilterClickHandle}
          />
          {category?.children.map((subCategory) => (
            <FilterRow isSubRow key={subCategory.id}>
              <CheckboxCommon
                id={`categorie_${subCategory.id}`}
                name={subCategory[`name_${locale}`]}
                label={subCategory[`name_${locale}`]}
                data-filter-name={SEARCH_FILTERS.FILTERS_CATEGORY_IDS}
                data-value={subCategory.id.toString()}
                checked={
                  !!query[SEARCH_FILTERS.FILTERS_CATEGORY_IDS] &&
                  // @ts-ignore
                  JSON.parse([
                    query[SEARCH_FILTERS.FILTERS_CATEGORY_IDS],
                  ]).includes(subCategory.id.toString())
                }
                onChange={onMultipleFilterClickHandle}
              />
            </FilterRow>
          ))}
        </FilterRow>
      ))}
    </SimpleCollapse>
  );
};

CategoriesFilters.propTypes = {
  query: PropTypes.object.isRequired,
  onMultipleFilterClickHandle: PropTypes.func.isRequired,
  courseCategories: PropTypes.array,
  locale: PropTypes.string,
};

export default memo(CategoriesFilters);
